import React, {useState} from 'react';
import {Flex} from '@priority-software/priority-style-react';
import ReportsList from '../componenets/ReportList';
import {AddNewReportBtn} from '../componenets/AddNewReportBtn/AddNewReportBtn';
import styles from './styles.module.scss';
import FormSelectDialog from '../componenets/FormSelectDialog';
import SearchInput from '../componenets/SearchInput';
import {observer} from 'mobx-react-lite';
import {reportGeneratorsStore} from '../stores/ReportGeneratorsStore';
import {CircularLoader} from '../../../components/CircularLoader/CircularLoader';
import {sendAnalyticsMonitor} from '../../../utils/monitoring';
import {createDataTestId} from '../../../utils/dataTestId';
import {monitorTransactionValues, ChartType} from '../consts';
import {setIsNavigationEnabled} from '../../../_shared/GWTBridge/invoke/genPage';

interface Props {
    isLoading: boolean;
}

const MainPage = observer(({isLoading}: Props) => {
    const [isNewReportDialogOpen, setIsNewReportDialogOpen] = useState<boolean>(false);

    const toggleNewReportDlg = (isOpen: boolean) => {
        setIsNewReportDialogOpen(isOpen);
        setIsNavigationEnabled(!isOpen);
        const {currentScreen} = reportGeneratorsStore;
        if (currentScreen) {
            currentScreen.setSelectedForm(null);
            currentScreen.setCurrentType(ChartType.report);
        }
    };

    if (isLoading) {
        return (
            <Flex justifyContent="center" componentClasses={styles.loader}>
                <CircularLoader />
            </Flex>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.header} {...createDataTestId('reports-main-page-header')}>
                <Flex componentClasses={styles.flexConainter}>
                    <AddNewReportBtn toggleNewReportDlg={toggleNewReportDlg} />
                    <SearchInput
                        searchQuery={reportGeneratorsStore.currentScreen?.listSearchQuery}
                        onChangeQuery={reportGeneratorsStore.currentScreen?.setSearchQuery}
                    />
                </Flex>
            </div>
            <div
                className={styles.mainPageContent}
                {...createDataTestId('reports-main-page-content')}
            >
                <ReportsList
                    onAddReport={() => {
                        toggleNewReportDlg(true);
                        sendAnalyticsMonitor(monitorTransactionValues.AnalyticsMainNew);
                    }}
                    searchQuery={reportGeneratorsStore.currentScreen?.listSearchQuery}
                />
                {isNewReportDialogOpen && (
                    <FormSelectDialog onClose={() => toggleNewReportDlg(false)} />
                )}
            </div>
        </div>
    );
});

export default MainPage;
